<template>
  <div class="main">
    <van-field
      v-model="form.phone"
      input-align="right"
      label="联系电话"
      name="phone"
      type="tel"
      required
      class="phone"
      oninput="if (value.length > 11) value = value.slice(0, 11)"
      placeholder="请输入联系电话"
      @blur="onBlur"
    />
    <van-field
      v-model.trim="form.content"
      rows="3"
      class="suggest"
      autosize
      type="textarea"
      placeholder="请输入您要反馈的意见..."
      show-word-limit
      @blur="onBlur"
    />
    <div class="save" @click="confirm">提交</div>
  </div>
</template>

<script>
import { setSuggestion } from '@/api/api'
export default {
  name: 'Suggest',
  data() {
    return {
      form: {
        phone: '', // 手机号
        content: '', // 内容
        type: 1 // 类型，1-意见，2-投诉
      }
    }
  },
  methods: {
    onBlur() {
      window.scrollTo(0, 0)
    },
    async confirm() {
      if (!this.form.phone) {
        this.$dialog.alert({
          message: '请输入手机号'
        })
        return
      }
      if (!this.form.content) {
        this.$dialog.alert({
          message: '请输入内容'
        })
        return
      }
      await setSuggestion(this.form)
      this.$dialog.alert({ message: '您的建议，已成功提交' })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px;
  background: #ffffff;
  .phone{
    background: rgba(242, 242, 242, 1);
    border-radius: 12px;
    margin-bottom: 30px;
  }
  .suggest {
    background: rgba(242, 242, 242, 1);
    height:300px;
    border-radius: 12px;
  }
  .save {
    margin-top: 184px;
    width: 690px;
    height: 100px;
    background: rgba(253, 106, 66, 1);
    border-radius: 12px;
    line-height: 100px;
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
